import * as React from 'react';
import { Text, View, Image } from '@react-pdf/renderer';
import { styles } from '../PDFStyle';
import { IProjectInfoForm } from '../../../pages/ProjectInfo/IProjectInfo';
import { useTranslation } from 'react-i18next';

interface IProjectInformationProps {
    projectInfo: IProjectInfoForm;
    results: any;
    width?: string;
}

const ProjectInformation = (props: IProjectInformationProps) => {
    const { t } = useTranslation();
    const { projectInfo, results, width } = props;
    //const projectDescription = projectInfo!.projectType == "Macro1" ?  t('project_type_macro1_description_button') :  t('project_type_macro2_description_button');

    return (
        <View style={{ width: width ?? '100%' }}>
            <Text style={styles.title}>{t('pdf_project_information')}</Text>

            <View style={styles.body}>
                <View style={styles.flexColumn}>
                    <Text style={styles.boldGreen}>
                        {t('pdf_title')}
                    </Text>
                    <Text>
                        {projectInfo!.projectName}
                    </Text>
                    <Text style={styles.boldGreen}>
                        {t('pdf_number')}
                    </Text>
                    <Text>
                        {projectInfo!.nrProject}
                    </Text>
                    <Text style={styles.boldGreen}>
                        {t('pdf_owner')}
                    </Text>
                    <Text>
                        {projectInfo!.owner}
                    </Text>
                </View>
                <View style={styles.flexColumn}>
                    <Text style={styles.boldGreen}>
                        {t('pdf_firm')}
                    </Text>
                    <Text>
                        {projectInfo!.designerFirmName}
                    </Text>
                    <Text style={styles.boldGreen}>
                        {t('pdf_country')}
                    </Text>
                    <Text>
                        {projectInfo!.designerFirmCountry}
                    </Text>
                    <Text style={styles.boldGreen}>
                        {t('pdf_city')}
                    </Text>
                    <Text>
                        {projectInfo!.designerFirmCity}
                    </Text>
                </View>
                {results?.mapImage && <View style={styles.flexColumn}>
                    <Image source={results.mapImage} style={styles.map}></Image>
                </View>}
            </View>
            {/* Mostra la sezione Note solo se ci sono delle note */}
            {projectInfo?.notes && projectInfo.notes.trim().length > 0 && (
                <>
                    <View style={[styles.flexColumn90, { marginTop: -20 }]}>
                        <Text style={styles.boldGreenNote}>
                            {t('pdf_notes')}
                        </Text>
                        <Text style={styles.notesRow}>
                            {projectInfo.notes}
                        </Text>
                    </View>
                </>
            )}
        </View>
    );
};

export default ProjectInformation;
